<template>
	<ViewPhoto
		v-if="imageShow && photos.length"
		:key="photosIndex"
		:images="photos"
		:index="photosIndex"
		@close="imageShow = false"
	/>
	<div
		class="
			fixed
			inset-y-0
			right-0
			pl-10
			flex
			side-over
			w-720
			z-50
			overflow-y-auto
		"
	>
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl"
			style="min-height: 100vh; height: fit-content"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center">
						<div class="text-4xl font-bold text-neutral-700 ml-1.5">
							Chi tiết mục tiêu
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div
				v-if="!isLoading"
				class="__goal-management-student-detail p-10 md-down:px-4"
			>
				<div class="flex items-center justify-between">
					<div v-if="groupClass" class="flex gap-2 ">
						<UserGroup
							:data="groupClass?.students"
							placement="bottom-start"
						/>
						<div>
							<div class="text-neutral-700 font-bold text-4xl">
								{{ groupClass?.name }}
							</div>
							<div class="uppercase text-green-500 font-semibold">
								{{ groupClass?.students?.length }} học sinh
							</div>
						</div>
					</div>
					<div
							class="luca-button cursor-pointer whitespace-nowrap"
							@click="router.push(`/group-class/${id}/${props.goalId}`)"
						>
							Xem toàn trang
						</div>
				</div>
				<div class="bg-white shadow-sm rounded-2xl mt-12">
					<div class="flex items-center justify-between p-6">
						<div class="font-semibold text-neutral-600">
							Nội dung mục tiêu
						</div>
					</div>
					<div class="px-6 pb-6">
						<div class="border p-4 rounded-lg">
							<div
								class="
									flex
									items-center
									md-down:flex-col md-down:items-start
								"
							>
								<div
									class="
										w-1/5
										text-neutral-400
										font-semibold
										text-xs
									"
									style="min-width: 200px; width: 200px"
								>
									NỘI DUNG
								</div>
								<div
									class="text-neutral-600 font-semibold"
									v-html="goal?.name"
								></div>
							</div>
							<div
								class="
									flex
									items-center
									mt-6
									md-down:flex-col md-down:items-start
								"
							>
								<div
									class="
										w-1/5
										text-neutral-400
										font-semibold
										text-xs
									"
									style="min-width: 200px; width: 200px"
								>
									LĨNH VỰC
								</div>
								<div class="text-neutral-600">
									{{ goal?.skill?.name }}
								</div>
							</div>
							<div
								v-if="org.enable_goal_assistance_level"
								class="flex mt-6 md-down:flex-col items-start"
							>
								<div
									class="
										w-1/5
										text-neutral-400
										font-semibold
										text-xs
										mt-2
									"
									style="min-width: 200px; width: 200px"
								>
									MỨC ĐỘ HỖ TRỢ
								</div>
								<div>
									<div
										v-for="ass in goal?.assistance_levels"
										:key="ass"
										class="text-neutral-600 mb-2"
									>
										{{ ass || '-' }}
									</div>
								</div>
							</div>
							<div
								v-if="org.enable_goal_reason"
								class="
									flex
									items-center
									mt-6
									md-down:flex-col md-down:items-start
								"
							>
								<div
									class="
										w-1/5
										text-neutral-400
										font-semibold
										text-xs
									"
									style="min-width: 200px; width: 200px"
								>
									CƠ SỞ HỢP LÝ
								</div>
								<div class="text-neutral-600">
									{{ goal?.reason || '-' }}
								</div>
							</div>
							<div
								v-if="org.enable_goal_strategy"
								class="
									flex
									items-center
									mt-6
									md-down:flex-col md-down:items-start
								"
							>
								<div
									class="
										w-1/5
										text-neutral-400
										font-semibold
										text-xs
									"
									style="min-width: 200px; width: 200px"
								>
									CHIẾN LƯỢC
								</div>
								<div class="text-neutral-600">
									{{ goal?.strategy || '-' }}
								</div>
							</div>
							<div
								v-if="org.enable_goal_process"
								class="
									flex
									items-center
									mt-6
									md-down:flex-col md-down:items-start
								"
							>
								<div
									class="
										w-1/5
										text-neutral-400
										font-semibold
										text-xs
									"
									style="min-width: 200px; width: 200px"
								>
									QUY TRÌNH THỰC HIỆN
								</div>
								<div
									class="text-neutral-600"
									style="
										white-space: pre-wrap;
										word-wrap: break-word;
									"
									v-html="goal?.process"
								></div>
							</div>
						</div>
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Media của mục tiêu
						</div>
					</div>
				</div>
				<div v-if="goal?.goal_media?.length">
					<div
						class="
							grid grid-cols-2
							md:grid-cols-3
							lg:grid-cols-6
							gap-4
						"
					>
						<div
							v-for="i in countMedia(goal)"
							:key="i"
							class="rounded-lg bg-neutral-200 relative"
							style="aspect-ratio: 1"
							@click="openMediaPopup(goal?.goal_media, i - 1)"
						>
							<img
								v-if="
									goal?.goal_media[i - 1]?.asset_type ===
									'image'
								"
								:src="loadImage(goal?.goal_media[i - 1])"
								alt=""
								class="rounded-lg object-cover shadow-lg"
								style="aspect-ratio: 1; height: 100%"
							/>
							<img
								v-else-if="
									loadThumbnail(goal?.goal_media[i - 1])
								"
								:src="loadThumbnail(goal?.goal_media[i - 1])"
								alt=""
								class="rounded-lg object-cover shadow-lg"
								style="aspect-ratio: 1; height: 100%"
							/>
							<div v-else class="relative">
								<img
									alt=""
									class="rounded-lg object-cover shadow-lg"
									src="../../assets/images/background/auth.png"
									style="aspect-ratio: 1; height: 100%"
								/>
							</div>
							<div
								class="absolute inset-0 bg-black opacity-20"
							></div>
							<div
								v-if="
									goal?.goal_media[i - 1]?.asset_type ===
									'video'
								"
								class="absolute flex flex-col items-center"
								style="
									left: 50%;
									top: 50%;
									transform: translate(-50%, -50%);
								"
							>
								<svg
									fill="none"
									height="55"
									viewBox="0 0 55 55"
									width="55"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g opacity="0.5">
										<rect
											fill="black"
											height="54.5"
											rx="27.25"
											width="54.5"
										/>
										<path
											d="M34.4948 28.5672L24.9024 36.9606C23.7709 37.9507 22 37.1471 22 35.6436V18.8568C22 17.3532 23.7709 16.5497 24.9024 17.5397L34.4948 25.9332C35.2917 26.6304 35.2917 27.8699 34.4948 28.5672Z"
											fill="white"
										/>
									</g>
								</svg>
							</div>
							<div
								v-if="goal?.goal_media[i - 1]?.inserted_at"
								class="
									absolute
									bottom-2
									left-4
									z-10
									font-medium
									text-white
								"
							>
								{{
									$filters.formatDate(
										goal?.goal_media[i - 1]?.inserted_at
									)
								}}
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="text-center text-neutral-500">
						Mục tiêu này hiện chưa có hình ảnh / video nào được tải
						lên.
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white							
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Hoạt động
						</div>
					</div>
				</div>
				<div
					v-if="goal?.group_activities?.length"
					class="shadow-sm sm:rounded-2xl overflow-hidden"
				>
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="
								overflow-hidden
								sm:rounded-t-2xl
								w-fit
								min-w-full
							"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-16
												whitespace-nowrap
											"
											scope="col"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
											"
											scope="col"
										>
											HOẠT ĐỘNG
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												relative
											"
											scope="col"
										>
											SỐ LẦN ĐƯỢC DẠY
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											activity, i
										) in goal?.group_activities"
										:key="activity.id"
										:class="
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div class="ml-2">
												{{ i + 1 }}
											</div>
										</td>
										<td
											class="px-6 py-4 text-neutral-700"
											style="width: 50%; min-width: 220px"
										>
											<div class="flex items-center">
												{{ activity.name }}
											</div>
										</td>
										<td class="px-6 py-4 text-neutral-700">
											<div class="flex items-center">
												{{
													activity.group_activity_used_count ||
													0
												}}
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div v-else class="flex items-center justify-center flex-col">
					<div class="text-center text-neutral-500">
						Mục tiêu này hiện chưa có hoạt động nào được thêm vào.
					</div>
				</div>
				<div class="relative my-12">
					<div
						aria-hidden="true"
						class="absolute inset-0 flex items-center"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="
								px-2.5
								py-1
								bg-white
								text-neutral-600
								font-semibold
								pb-1
								text-2xl
							"
						>
							Lịch sử của mục tiêu
						</div>
					</div>
				</div>
				<div class="mt-14">
					<div v-if="goal?.completed_at" class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div
							class="
								relative
								flex
								items-center
								justify-between
								mb-2
							"
						>
							<span
								class="
									pr-3
									bg-white
									text-lg
									font-semibold
									text-neutral-600
								"
							>
								{{ $filters.formatDate(goal?.completed_at) }}
							</span>
							<div
								class="
									pl-3
									bg-white
									text-neutral-600
									flex
									items-center
								"
							>
								<span class="mr-2">Hoàn thành mục tiêu</span>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z"
										fill="#2AA797"
										fill-rule="evenodd"
									/>
								</svg>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-14">
					<div v-if="goal?.stopped_at" class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div
							class="
								relative
								flex
								items-center
								justify-between
								mb-2
							"
						>
							<span
								class="
									pr-3
									bg-white
									text-lg
									font-semibold
									text-neutral-600
								"
							>
								{{ $filters.formatDate(goal?.stopped_at) }}
							</span>
							<div
								class="
									pl-3
									bg-white
									text-neutral-600
									flex
									items-center
								"
							>
								<span class="mr-2">Tạm dừng mục tiêu</span>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.83333 9.16667C5.48816 9.16667 5.20833 9.53976 5.20833 10C5.20833 10.4602 5.48816 10.8333 5.83333 10.8333H14.5833C14.9285 10.8333 15.2083 10.4602 15.2083 10C15.2083 9.53976 14.9285 9.16667 14.5833 9.16667H5.83333Z"
										fill="#E37056"
										fill-rule="evenodd"
									/>
								</svg>
							</div>
						</div>
					</div>
					<div v-for="ass in assessments" :key="ass.tag">
						<div class="mt-10">
							<div class="font-semibold text-neutral-600 text-lg">
								{{ ass.tag }}
							</div>
						</div>
						<div
							class="
								shadow-sm
								sm:rounded-2xl
								overflow-hidden
								mt-8
							"
						>
							<div class="overflow-x-auto scroll-bar">
								<div
									class="
										overflow-hidden
										sm:rounded-t-2xl
										w-fit
										min-w-full
									"
								>
									<table
										class="
											min-w-full
											divide-y
											text-neutral-200
										"
									>
										<thead class="bg-neutral-100 h-16">
											<tr>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
												>
													Tuần
												</th>
												<th
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 350px"
												>
													Hoạt động
												</th>
												<th
													class="
														px-3
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
													scope="col"
													style="width: 100px"
												>
													ALBUM
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													aByWeek, index
												) in ass.group_activities_group_by_week"
												:key="index"
												:class="
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="text-neutral-700"
											>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													{{ aByWeek.week }}
												</td>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div>
														<div
															v-if="
																aByWeek
																	.group_activities
																	?.length
															"
														>
															<div
																v-for="a in aByWeek.group_activities"
																:key="a.id"
																class="mb-2"
															>
																{{ a.name }}
															</div>
														</div>
													</div>
												</td>
												<td
													class="
														whitespace-nowrap
														text-neutral-700
													"
												>
													<div
														v-if="
															aByWeek.goal_media
																?.length
														"
														class="pl-5 py-4"
														@click="
															openMediaPopup(
																aByWeek.goal_media,
																0
															)
														"
													>
														<svg
															fill="none"
															height="20"
															viewBox="0 0 20 20"
															width="20"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
															<path
																clip-rule="evenodd"
																d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
														</svg>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, defineProps, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { $api } from '@/services';
import { useStore } from 'vuex';
import Loading from '@/components/common/Loading';
import ViewPhoto from '@/components/common/ViewPhoto.vue';
import UserGroup from '@/components/elements/UserGroup.vue';

const router = useRouter();
const route = useRoute();
const store = useStore();
const org = computed(() => store.state.profile.current_org);
const goal = ref(null);
const imageShow = ref(false);
const isLoading = ref(true);
const photosIndex = ref(0);
const photos = ref([]);
const id = ref(route.params.id);
const groupClass = ref(null);
const props = defineProps(['goalId', 'sideOverShow']);
const assessments = ref([]);

watch(
	() => props.sideOverShow,
	() => {
		if (props.goalId) {
			fetchGroupClassDetail();
			fetchGoal();
		}
	}
);

async function fetchGoal() {
	try {
		const { data } = await $api.groupClasses.goalDetail(
			String(id.value),
			String(props.goalId),
			{}
		);
		if (data?.data) {
			goal.value = data?.data;
			assessments.value = [
				...goal.value.list_group_lesson_activities?.before_stops,
				...goal.value.list_group_lesson_activities?.after_stops,
			];
		}
	} catch (e) {
		console.log(e);
	} finally {
		isLoading.value = false;
	}
}

async function fetchGroupClassDetail() {
	try {
		const {
			data: { data },
		} = await $api.groupClasses.detail(String(id.value));
		groupClass.value = data;
	} catch (e) {
		console.log(e);
	}
}
function countMedia(g) {
	return g?.goal_media >= 6 ? 6 : g?.goal_media?.length;
}
function loadImage(asset) {
	const imageRequest = JSON.stringify({
		bucket: asset.image_bucket,
		key: asset.asset_key,
		edits: {
			width: 400,
			height: 400,
		},
	});
	return `${asset.image_cloudfront_url}/${btoa(imageRequest)}`;
}
function loadThumbnail(asset) {
	const imageRequest = JSON.stringify({
		bucket: asset.image_bucket,
		key: asset.video_poster_asset_key,
		edits: {
			width: 400,
			height: 400,
		},
	});
	return `${asset.image_cloudfront_url}/${btoa(imageRequest)}`;
}
function openMediaPopup(media, index) {
	imageShow.value = true;
	photos.value = media;
	photosIndex.value = index;
}
</script>
<style scoped>
.w-720 {
	width: 720px !important;
}
</style>
